import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';

import { adminPageNames } from '../../shared/adminPageNames';
import { byField } from '../../../utils/sorting';
import {
  columnHeaders,
  MIN_COLUMNS_NUMBER,
  MAX_COLUMNS_NUMBER,
  GRID_FIELD_MAPPINGS,
} from '../xlsxImport/constants';
import columnIndexToName from '@common/xlsxExport/utils/columnIndexToName';
import { categoriesStaticSelector } from '../../../shared/store/selectors';

const keyBy = (key, collection) => collection.reduce((acc, item) => {
  acc[item[key]] = item;
  return acc;
}, {});

export const sharedSelectors = getSelectors(adminPageNames.TLS_ACCOUNTS);

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TLS_ACCOUNTS].enabledFlagValues,
  values => values.map(({ name, value }) => ({ label: name, value }))
);

export const generatingR2RChartSelector = ({ administration }) =>
  administration[adminPageNames.TLS_ACCOUNTS].generatingR2RChart;

export const isFetchingInitialDataForModalSelector = ({ administration }) =>
  administration[adminPageNames.TLS_ACCOUNTS].isFetchingInitialDataForModal;

export const tagsSelector = ({ administration }) =>
  administration[adminPageNames.TLS_ACCOUNTS].tags;

export const tlsAccountsSelector = createSelector(
  state => state.administration[adminPageNames.TLS_ACCOUNTS].tlsAccounts,
  tlsAccounts => tlsAccounts.map(({
    account,
    desciption,
  }) => ({
    label: account,
    value: account,
    desciption,
  }))
);

export const tagsDescriptionsSelector = createSelector(
  tagsSelector,
  tags => keyBy('tagName', tags)
);

export const categoriesWithTagsSelector = ({ administration }) =>
  administration[adminPageNames.TLS_ACCOUNTS].categoriesWithTags;

export const categoriesWithTagsForModalSelector = createSelector(
  categoriesStaticSelector,
  categoriesWithTagsSelector,
  tagsDescriptionsSelector,
  (categoriesStatic, categoriesWithTags, tagsDescriptions) => categoriesWithTags
    .filter(category => categoriesStatic.find(({ categoryName }) => categoryName === category.categoryName))
    .map(category => ({
      ...category,
      tags: (category.tags ? category.tags.split(';') : [])
        .map(tag => ({
          value: tag ? tagsDescriptions[tag].description : '',
          label: tag ? tagsDescriptions[tag].description : '',
        }))
        .sort(byField('value')),
    }))
);

export const excelOptionsSelector = createSelector(
  categoriesStaticSelector,
  categories => ({
    fieldMappings: GRID_FIELD_MAPPINGS(categories),
    columnHeaders: columnHeaders(categories),
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER(categories),
    lastColumnLetter: columnIndexToName(MAX_COLUMNS_NUMBER(categories) - 1),
  })
);
